(function () {
  var drawer = document.getElementById("sf-cart-drawer");
  var body = drawer && drawer.querySelector("[data-sf-cart-body]");
  var countEls = document.querySelectorAll("[data-sf-cart-count], .sf-cart-link__count");
  var variantId = document.body.getAttribute("data-sf-variant");

  function money(cents) {
    return "£" + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function render(cart) {
    countEls.forEach(function (el) { el.textContent = String(cart.item_count); });
    var basket = document.querySelector(".sf-cart-link");
    if (basket) basket.setAttribute("aria-label", "Basket (" + cart.item_count + ")");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="sf-cart-drawer__empty">Your basket is empty.</p><p><a class="btn btn--primary" href="/collections/shop">Continue shopping</a></p>';
      return;
    }
    var html = '<div class="sf-cart-drawer__items">';
    cart.items.forEach(function (item) {
      html += '<div class="sf-cart-line">' +
        (item.image ? '<img src="' + item.image + '" alt="">' : "") +
        '<div><a href="' + item.url + '">' + item.product_title + "</a><div>" +
        item.quantity + " × " + money(item.final_price) + "</div></div></div>";
    });
    html += "</div><p style=\"margin-top:1rem;font-weight:800;\">Total " + money(cart.total_price) + "</p>";
    html += cart.total_price >= 2500
      ? '<p style="margin:.35rem 0 0;">Free UK delivery.</p>'
      : '<p style="margin:.35rem 0 0;">UK delivery £3.95 at checkout. Free over £25, or buy 3 for £25.</p>';
    html += '<a class="btn btn--primary btn--block" href="/checkout" style="margin-top:.8rem;">Checkout</a>';
    html += '<a class="btn btn--secondary btn--block" href="/cart" style="margin-top:.5rem;">View basket</a>';
    body.innerHTML = html;
  }

  function showError(message) {
    if (!body) return;
    body.innerHTML = '<p class="sf-cart-drawer__error">' + message + "</p>";
    openDrawer();
  }

  function refresh() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function storedClick(key, value) {
    try {
      if (value) localStorage.setItem(key, value);
      return localStorage.getItem(key) || "";
    } catch (err) {
      return value || "";
    }
  }

  function saveClickIds() {
    var params = new URLSearchParams(window.location.search);
    var gclid = storedClick("sf_gclid", params.get("gclid"));
    var fbclid = storedClick("sf_fbclid", params.get("fbclid"));
    var attributes = {};
    if (gclid) attributes.gclid = gclid;
    if (fbclid) attributes.fbclid = fbclid;
    if (!gclid && !fbclid) return Promise.resolve();
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).catch(function () {});
  }

  function trackAdd(data) {
    var item = (data && data.items && data.items[0]) || data || {};
    var qty = Number(item.quantity) || 1;
    var unit = Number(item.final_price || item.price || 1000) / 100;
    if (window.sfTrack) {
      window.sfTrack("AddToCart", {
        id: String(item.variant_id || item.id || variantId || ""),
        name: item.product_title || item.title || "SwimFresh",
        value: Math.round(unit * qty * 100) / 100,
        quantity: qty
      });
    }
  }

  function addItem(id, qty) {
    if (!id) {
      showError("This product is not ready to add yet.");
      return Promise.reject(new Error("missing variant"));
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error((data && (data.description || data.message)) || "Could not add to basket");
        }
        return data;
      });
    }).then(function (data) {
      trackAdd(data);
      return refresh();
    }).then(openDrawer);
  }

  saveClickIds();

  document.addEventListener("click", function (e) {
    var checkout = e.target.closest("a[href='/checkout'], a[href$='/checkout']");
    if (checkout && !checkout.getAttribute("data-sf-go")) {
      e.preventDefault();
      var href = checkout.getAttribute("href");
      var tracked = fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.sfTrack) {
            window.sfTrack("InitiateCheckout", {
              value: (Number(cart.total_price) || 0) / 100,
              quantity: cart.item_count || 1
            });
          }
        })
        .catch(function () {
          if (window.sfTrack) window.sfTrack("InitiateCheckout", { value: 10, quantity: 1 });
        });
      var go = function () { window.location.href = href; };
      Promise.race([
        Promise.all([saveClickIds(), tracked]),
        new Promise(function (resolve) { window.setTimeout(resolve, 600); })
      ]).then(go, go);
      return;
    }
    var add = e.target.closest("[data-sf-add]");
    if (add) {
      e.preventDefault();
      addItem(add.getAttribute("data-sf-variant") || variantId, add.getAttribute("data-sf-add")).catch(function (err) {
        showError(err.message || "Could not add to basket");
      });
      return;
    }
    if (e.target.closest("[data-sf-cart-open]")) {
      e.preventDefault();
      refresh().then(openDrawer);
    }
    if (e.target.closest("[data-sf-cart-close]")) closeDrawer();
    if (e.target.closest("[data-sf-news-close]")) closeNews(true);
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains("cart")) return;
    var idInput = null;
    form.querySelectorAll("[name='id']").forEach(function (input) {
      if (input.value) idInput = input;
    });
    var qtyInput = form.querySelector("[name='quantity']");
    if (!idInput) return;
    e.preventDefault();
    addItem(idInput.value, qtyInput ? qtyInput.value : 1).catch(function (err) {
      showError(err.message || "Could not add to basket");
    });
  });

  var newsKey = "sf-email-popup";
  var newsCooldown = 14 * 24 * 60 * 60 * 1000;

  function newsRoot() {
    return document.getElementById("sf-news");
  }

  function rememberNews(value) {
    try { localStorage.setItem(newsKey, value); } catch (err) {}
  }

  function openNews(fromUser) {
    var news = newsRoot();
    if (!news) return;
    news.hidden = false;
    if (fromUser) {
      var email = news.querySelector("input[type='email']");
      if (email) email.focus();
    }
  }

  function closeNews(store) {
    var news = newsRoot();
    if (!news || news.hidden) return;
    news.hidden = true;
    if (!store) return;
    if (news.querySelector("[data-sf-news-success]")) rememberNews("subscribed");
    else rememberNews(String(Date.now()));
  }

  window.swimfreshOpenEmailPopup = function () {
    openNews(true);
  };

  (function scheduleNews() {
    var news = newsRoot();
    if (!news) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (news.querySelector("[data-sf-news-success]")) {
      rememberNews("subscribed");
      openNews(false);
      return;
    }
    if (news.querySelector("[data-sf-news-error]")) {
      openNews(false);
      return;
    }
    var stored = "";
    try { stored = localStorage.getItem(newsKey) || ""; } catch (err) {}
    if (stored === "subscribed") return;
    var dismissedAt = Number(stored);
    if (dismissedAt && Date.now() - dismissedAt < newsCooldown) return;
    window.setTimeout(function tryOpen() {
      if (drawer && drawer.classList.contains("is-open")) return;
      var menu = document.querySelector("[data-nav]");
      if (menu && menu.classList.contains("is-open")) return;
      var banner = document.getElementById("shopify-pc__banner");
      if (banner) {
        var style = window.getComputedStyle(banner);
        if (style.display !== "none" && style.visibility !== "hidden") {
          window.setTimeout(tryOpen, 800);
          return;
        }
      }
      openNews(false);
    }, 8000);
  })();

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeDrawer();
      closeNews(true);
    }
  });

  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector(".gallery__main");
    gallery.querySelectorAll("[data-gallery-src]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (!main) return;
        main.src = button.getAttribute("data-gallery-src");
        main.alt = button.getAttribute("data-gallery-alt") || "";
        gallery.querySelectorAll(".thumbs__btn").forEach(function (other) {
          other.classList.remove("is-active");
        });
        button.classList.add("is-active");
      });
    });
  });

  var menuToggle = document.querySelector("[data-menu-toggle]");
  var nav = document.querySelector("[data-nav]");
  if (menuToggle && nav) {
    menuToggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
      menuToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    });
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        nav.classList.remove("is-open");
        menuToggle.setAttribute("aria-expanded", "false");
        menuToggle.setAttribute("aria-label", "Open menu");
      });
    });
  }

  refresh();
})();
